<template>
  <div>
    <div style="display: none">
      <slot></slot>
    </div>

    <h1>{{ $t("newTrip.title") }}</h1>

    <router-view>
      <slot></slot>
    </router-view>
  </div>
</template>

<script>
export default {
  name: "NewTrip",
  created: function() {
    this.$store.dispatch("DelegationOrder/newTripStart");
  },
  mounted() {
    this.$store.dispatch("Visual/setHalfBackground");
  },
  beforeDestroy() {
    this.$store.dispatch("Visual/setWhiteBackground");
  }
};
</script>

<style scoped></style>
